import type { InsertTagTypeGroupByNameMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeGroupByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { CreateTagTypeGroupInput } from './types';

export const useInsertTagTypeGroupByName = createMutationHook({
  name: 'insertTagTypeGroup',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.tag.insertTagTypeGroup.mutationOptions({ onSuccess }),
  mapInput: (variables: CreateTagTypeGroupInput) => ({
    Name: variables.Name ?? '',
  }),
  invalidate: (trpc) => [trpc.frontend.tag.pathKey()],
  mapResponse: (result: { Id: string }): InsertTagTypeGroupByNameMutation => ({
    insert_tag_type_group_one: {
      __typename: 'tag_type_group',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertTagTypeGroupByNameDocument,
  graphqlVariables: (variables: CreateTagTypeGroupInput) => ({
    ...variables,
  }),
});
